import React from "react";
import "./NotFoundPage.css";

const NotFoundPage = () => (
    <main className="not-found-page">
        <section className="not-found-card">
            <span>404</span>
            <h1>Page not found</h1>
            <p>Nothing was found in this URL. Please go back and use the correct link.</p>
        </section>
    </main>
);

export default NotFoundPage;
